export default ( props : { height ?: number | string, align ?: 'top'|'middle'|'bottom', children ?: any, bgc ?: string, style ?: any  }) => {
    return <div style={{ display : 'inline-block', width : 'auto', backgroundColor : props.bgc ? props.bgc : '', ...props.style}}>
        <div style={{ display : 'table-cell', height : props.height ? props.height : 30, verticalAlign : props.align ? props.align : 'middle'}}>
            {props.children}
        </div>
    </div>
  }